<template lang="pug">
  .lista-clientes
    div(v-if="seleccionado")
      .title
        span Cliente {{ clienteSeleccionado.codigo }} {{ clienteSeleccionado.nombre}} seleccionado
      button.button.is-small(@click="deseleccionar") Deseleccionar
    div(v-else)
      .title
        span Clientes

      .pull-right
        button.button.is-small(
            @click="actualizarTodos"
            :class="{'is-loading': isUpdating}"
          ) Actualizar todos

      .agregar
        span Ingresa el codigo del cliente para agregregarlo
        .field.d-flex.ai-center.jc-center
          .control
            v-text-field.is-empresa(type="number"  label="Codigo de cliente", solo, dense, v-model="codigoClienteAgregar")
        button.button.is-small(
          @click="agregar"
          :class="{'is-loading': isAdding}"
        ) Agregar

      .body
        table.table.is-striped.is-bordered
          thead
            th Codigo
            th Nombre
            th
          tbody(
            name="table-row"
            is="transition-group"
          )
            tr.row-table(
              v-for="(o, index) in lista"
              :key="index"
            )
              td {{ o.codigo }}
              td {{ o.nombre }}
              td
                .contenedor-acciones
                  button.button.is-small(@click="ver(o)") Ver
                  button.button.is-small.is-danger(@click="remove(o)") Eliminar
</template>

<script>
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
export default {
  name: 'cliente_list',
  data () {
    return {
      isLoading: true,
      lista: [],
      clienteSeleccionado: {},
      seleccionado: false,
      codigoClienteAgregar: '',
      isAdding: false,
      isUpdating: false
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = { }
      apiGet(vm, '/admin/cliente', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    remove (o) {
      var vm = this

      var obj = {
        codigo: o.codigo
      }

      apiDelete(vm, '/admin/cliente', obj, function (data) {
        notify(vm, 'success', '', 'Eliminado correctamente')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    ver (o) {
      var vm = this
      vm.$emit('selected', o)
      vm.clienteSeleccionado.codigo = o.codigo
      vm.clienteSeleccionado.nombre = o.nombre
      vm.seleccionado = true
    },
    deseleccionar () {
      var vm = this
      vm.$emit('deselected')
      vm.clienteSeleccionado = {}
      vm.seleccionado = false
      vm.fetch()
    },
    agregar () {
      var vm = this

      if (!vm.codigoClienteAgregar) {
        notify(vm, 'error', 'Error', 'Ingrese un cliente')
        return
      }

      vm.isAdding = true
      var obj = {
        codigoCliente: vm.codigoClienteAgregar
      }

      apiPost(vm, '/admin/cliente', obj, function (data) {
        vm.codigoClienteAgregar = ''
        notify(vm, 'success', '', 'Datos guardados correctamente')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isAdding = false
      })
    },
    actualizarTodos () {
      var vm = this

      vm.isUpdating = true
      var obj = {
      }

      apiPost(vm, '/admin/cliente/all', obj, function (data) {
        notify(vm, 'success', '', 'Datos actualizados correctamente')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isUpdating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import('https://cdnjs.cloudflare.com/ajax/libs/bulma/0.4.4/css/bulma.min.css')
.contenedor-acciones
  display flex
  .button
    margin 0px 10px
    flex 1

.agregar
  display flex
  justify-content center
  margin-bottom 10px
  > *
    margin 0px 5px
</style>



// WEBPACK FOOTER //
// Component_Cliente_List.vue?4b6cb1e2